import { render, staticRenderFns } from "./Line.vue?vue&type=template&id=2938ca16&scoped=true"
import script from "./Line.vue?vue&type=script&lang=js"
export * from "./Line.vue?vue&type=script&lang=js"
import style0 from "./Line.vue?vue&type=style&index=0&id=2938ca16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938ca16",
  null
  
)

export default component.exports